/** "1 response", "2 responses": the count with its noun, singular only for 1. */
export function countOf(count: number, singular: string, plural = `${singular}s`): string {
    return `${count} ${count === 1 ? singular : plural}`;
}
